<template>
  <div :class="['HelpButton', {'HelpButton--dark': dark},  {'HelpButton--inactive': inactive}]"
    @click="$emit('click', $event.target.value)"
  >
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.40558 6.55509C2.40558 6.14598 2.48259 5.788 2.63662 5.48117C2.79971 5.16504 2.98998 4.90005 3.20743 4.68619C3.42489 4.47234 3.71029 4.23059 4.06366 3.96095C4.41702 3.69131 4.67071 3.46815 4.82474 3.29149C4.98783 3.11483 5.07391 2.91957 5.08297 2.70572C5.10109 2.3152 4.97424 2.01302 4.70243 1.79916C4.43967 1.58531 4.03648 1.47838 3.49284 1.47838C3.03075 1.47838 2.60944 1.59926 2.2289 1.841C1.85741 2.07345 1.5856 2.36169 1.41345 2.70572L0 1.75732C0.271817 1.23663 0.702193 0.813575 1.29113 0.488146C1.88006 0.162715 2.61397 0 3.49284 0C4.52575 0 5.37291 0.223152 6.03433 0.669456C6.69575 1.10646 7.0174 1.74802 6.99928 2.59414C6.99021 2.92887 6.90414 3.23106 6.74105 3.5007C6.58702 3.76104 6.40128 3.98884 6.18383 4.1841C5.97543 4.37936 5.69003 4.61181 5.3276 4.88145C4.88364 5.21618 4.55746 5.49977 4.34906 5.73222C4.14067 5.95537 4.03648 6.21106 4.03648 6.4993V6.79219H2.40558V6.55509ZM3.23462 10C2.92656 10 2.6638 9.88842 2.44635 9.66527C2.2289 9.44212 2.12017 9.17248 2.12017 8.85635C2.12017 8.54951 2.2289 8.28917 2.44635 8.07531C2.6638 7.85216 2.92656 7.74059 3.23462 7.74059C3.54268 7.74059 3.80543 7.85216 4.02288 8.07531C4.24034 8.28917 4.34906 8.54951 4.34906 8.85635C4.34906 9.17248 4.24034 9.44212 4.02288 9.66527C3.81449 9.88842 3.55174 10 3.23462 10Z"/>
    </svg>
    <div class="HelpButton-borders"></div>
  </div>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    inactive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .HelpButton
    width 24px
    height 24px
    border-radius 4px
    color white
    text-align center
    cursor pointer
    display flex
    align-items center
    justify-content center
    display inline-block
    position relative
    &-borders
      border-radius 4px
      position absolute
      width calc(100%)
      height calc(100%)
      border 1px solid white
      top 0
      left 0
      transform-origin  50% 50%
      z-index 1
      transition all 200ms linear
    svg
      position absolute
      width 16px
      fill white
      z-index 5
      top 50%
      left 50%
      transform translate(-50%, -50%)
    &:hover
      .HelpButton-borders
        background white
        transform scale(1.2)
      svg
        fill black

    &--dark
      .HelpButton-borders
        border 1px solid black
      svg
        fill black
      &:hover
        .HelpButton-borders
          background rgba(0, 0, 0, 1)
        svg
          fill white
    &--inactive
      user-select none
      pointer-events none
</style>
